import * as React from 'react';
import { cn } from '../../lib/cn';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, required, children, ...props }, ref) => {
    return (
      <label
        ref={ref}
        className={cn('nv-label', required && 'nv-label-required', className)}
        {...props}
      >
        {children}
      </label>
    );
  },
);
Label.displayName = 'Label';
